export const SIDE_CARD_MIN_HEIGHT_IN_PX = '450px'
